import { fetchModules } from '~graphql/controllers';
import { onErrorShowMessage } from '~src/errors';

/**
 * Fetches available credit modules
 * @param {Object} options - Options for fetching credit modules
 * @param {string} options.skuPrefix - SKU prefix to filter modules
 * @returns {Promise<Array|null>} Array of modules or null if fetching fails
 */
const fetchCreditModules = async ({ skuPrefix = '^ADD-CRE' } = {}) => {
  try {
    const where = {
      sku: {
        matchesRegex: skuPrefix,
      },
      is_product_line: {
        equalTo: false,
      },
      is_main: {
        equalTo: true,
      },
      is_active: {
        equalTo: true,
      },
    };
    return await fetchModules(where);
  } catch (error) {
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Attenzione!',
      text: 'Errore nel caricamento del listino prezzi dei crediti.',
      confirmButtonColor: '#278e8e',
    });
    console.error(error);
    return null;
  }
};

export default fetchCreditModules;
